import { IBlogPageViewModel } from 'Types/Litium';
import BlogMobileMenu from 'Pages/Blog/BlogMobileMenu';
import BlogMainContent from 'Pages/Blog/BlogMainContent';
import BlogLeftNavigation from 'Pages/Blog/BlogLeftNavigation';
import BlogRightNavigation from 'Pages/Blog/BlogRightNavigation';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

const BlogPage = ({
    pageHeaderImage,
    pageHeaderImageMobile,
    horizontalDividerImage,
    horizontalDividerImageMobile,
    vertiaclDividerImage,
    pageBackgroundHexColor,
    expandBlogListIconAriaLabel,
    expandMainBlogItemBodyText,
    blogMobileNavigationLinkText,
    filterTagListHeaderText,
    moreBlogItemsWrittenByText,
    writtenByText,
    noBlogItemsFoundText,
    authorLinkBase,
    searchLinkBase,
    navigationHeaderImage,
    missionAndVisionPageLink,
    thisWeeksAuthorsThumbnail,
    navigationTopLevelLinkList,
    navigationBlogItemLinkList,
    blogHomeLink,
    navigationBlogItemListHeaderText,
    archiveActionLink,
    allAuthorsActionLink,
    thisWeeksAuthorHeaderText,
    mainBlogItem,
    blogItemThumbnailList,
    blogSearchPlaceholderText,
    filterTagList,
}: IBlogPageViewModel) => (
    <div
        style={
            {
                '--bg-color': pageBackgroundHexColor,
            } as React.CSSProperties
        }
        className="flex flex-col bg-[var(--bg-color)]"
    >
        <picture>
            <source
                height={
                    pageHeaderImage.height > 0 ? pageHeaderImage.height : ''
                }
                width={pageHeaderImage.width > 0 ? pageHeaderImage.width : ''}
                media={`(min-width: ${tailwindBreakpoints.lg})`}
                srcSet={pageHeaderImage.src}
            />
            <img
                className="w-full"
                src={pageHeaderImageMobile.src}
                alt={pageHeaderImageMobile.altText}
                width={
                    pageHeaderImageMobile.width > 0
                        ? pageHeaderImageMobile.width
                        : ''
                }
                height={
                    pageHeaderImageMobile.height > 0
                        ? pageHeaderImageMobile.height
                        : ''
                }
            />
        </picture>

        <div className="mx-auto mb-14 mt-4 flex max-w-7xl flex-col lg:mt-10 lg:flex-row">
            <BlogLeftNavigation
                expandMainBlogItemBodyText={expandMainBlogItemBodyText}
                navigationHeaderImage={navigationHeaderImage}
                missionAndVisionPageLink={missionAndVisionPageLink}
                thisWeeksAuthorsThumbnail={thisWeeksAuthorsThumbnail}
                navigationTopLevelLinkList={navigationTopLevelLinkList}
                navigationBlogItemLinkList={navigationBlogItemLinkList}
                blogHomeLink={blogHomeLink}
                navigationBlogItemListHeaderText={
                    navigationBlogItemListHeaderText
                }
                archiveActionLink={archiveActionLink}
                allAuthorsActionLink={allAuthorsActionLink}
                thisWeeksAuthorHeaderText={thisWeeksAuthorHeaderText}
            />

            <BlogMobileMenu
                expandBlogListIconAriaLabel={expandBlogListIconAriaLabel}
                blogMobileNavigationLinkText={blogMobileNavigationLinkText}
                filterTagListHeaderText={filterTagListHeaderText}
                searchLinkBase={searchLinkBase}
                missionAndVisionPageLink={missionAndVisionPageLink}
                thisWeeksAuthorsThumbnail={thisWeeksAuthorsThumbnail}
                navigationTopLevelLinkList={navigationTopLevelLinkList}
                navigationBlogItemLinkList={navigationBlogItemLinkList}
                blogHomeLink={blogHomeLink}
                navigationBlogItemListHeaderText={
                    navigationBlogItemListHeaderText
                }
                archiveActionLink={archiveActionLink}
                allAuthorsActionLink={allAuthorsActionLink}
                thisWeeksAuthorHeaderText={thisWeeksAuthorHeaderText}
                blogSearchPlaceholderText={blogSearchPlaceholderText}
                filterTagList={filterTagList}
            />

            <BlogMainContent
                horizontalDividerImage={horizontalDividerImage}
                horizontalDividerImageMobile={horizontalDividerImageMobile}
                expandMainBlogItemBodyText={expandMainBlogItemBodyText}
                moreBlogItemsWrittenByText={moreBlogItemsWrittenByText}
                writtenByText={writtenByText}
                noBlogItemsFoundText={noBlogItemsFoundText}
                authorLinkBase={authorLinkBase}
                mainBlogItem={mainBlogItem}
                blogItemThumbnailList={blogItemThumbnailList}
            />

            <div
                aria-label={vertiaclDividerImage.altText}
                style={
                    {
                        'background-image': `url('${vertiaclDividerImage.src}')`,
                    } as React.CSSProperties
                }
                className="relative ml-9 mr-6 hidden w-8 min-w-[30px] overflow-hidden bg-auto bg-top lg:block"
            />

            <BlogRightNavigation
                filterTagListHeaderText={filterTagListHeaderText}
                searchLinkBase={searchLinkBase}
                blogSearchPlaceholderText={blogSearchPlaceholderText}
                filterTagList={filterTagList}
            />
        </div>
    </div>
);

export default BlogPage;
